














































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { maskDateTime, getSnackbarMessage } from '@/utils/common'
import { LayoutEmailFormModel } from '@/types/interfaces/LayoutEmailFormModel'
import LayoutEmailForm from '@/components/RemuneracaoMedica/financeiro/layout-email-form.vue'
import VariaveisPanel from '@/components/RemuneracaoMedica/financeiro/variaveis-panel.vue'
import PreviewNotificacaoEmail from '@/components/RemuneracaoMedica/financeiro/preview-notificacao-email.vue'

interface ResumoTipoNotificacao {
  tipo: { key: string, display: string }
  configurado: boolean
  ultimaAtualizacao: string | null
}

const formModelVazio = (): LayoutEmailFormModel => ({
  assunto: '',
  emailResposta: '',
  emailContato: '',
  emailCorpo: '',
  emailRodape: '',
})

@Component({
  components: { LayoutEmailForm, VariaveisPanel, PreviewNotificacaoEmail },
})
export default class ViewFinanceiroCadastroLayoutEmail extends Vue {
  fontePagadoraList: any[] = []
  loadingHospitais: boolean = false

  selectedHospitalId: string = ''
  resumo: ResumoTipoNotificacao[] = []
  loadingResumo: boolean = false

  itemEmEdicao: ResumoTipoNotificacao | null = null
  formModel: LayoutEmailFormModel = formModelVazio()
  showModalEditar: boolean = false
  loadingSalvar: boolean = false

  itemEmExclusao: ResumoTipoNotificacao | null = null
  showModalExcluir: boolean = false
  loadingExcluir: boolean = false

  showModalAplicarLote: boolean = false

  get qtdConfigurados(): number {
    return this.resumo.filter(item => item.configurado).length
  }

  get hospitalSelecionadoNome(): string {
    const hospital = this.fontePagadoraList.find(item => item.id === this.selectedHospitalId)
    return hospital ? hospital.nome : ''
  }

  @Watch('selectedHospitalId')
  async onHospitalChange() {
    await this.carregarResumo()
  }

  async carregarResumo() {
    if (!this.selectedHospitalId) {
      this.resumo = []
      return
    }

    this.loadingResumo = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getResumoNotificacao(this.selectedHospitalId)

    if (response.success) {
      this.resumo = response.data || []
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar os layouts do hospital.', 'error'))
    }

    this.loadingResumo = false
  }

  async abrirEdicao(item: ResumoTipoNotificacao) {
    this.itemEmEdicao = item
    this.formModel = formModelVazio()

    if (item.configurado) {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLayoutEmailById({
        hospitalId: this.selectedHospitalId,
        tipoNome: item.tipo.key,
      })

      if (!response.success || !response.data) {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar o layout de e-mail.', 'error'))
        return
      }

      this.formModel = {
        assunto: response.data.assunto,
        emailResposta: response.data.emailResposta,
        emailContato: response.data.emailContato,
        emailCorpo: response.data.emailCorpo,
        emailRodape: response.data.emailRodape,
      }
    }

    this.showModalEditar = true
  }

  inserirToken(token: string) {
    const form = this.$refs.form as any

    if (form && !form.inserirToken(token)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Variáveis não podem ser inseridas no Assunto.', 'error'))
    }
  }

  async salvar() {
    const form = this.$refs.form as any
    const formularioValido = form.validate()

    if (!formularioValido || !this.itemEmEdicao) {
      return
    }

    this.loadingSalvar = true

    const payload = {
      hospitalId: this.selectedHospitalId,
      tipo: this.itemEmEdicao.tipo.key,
      ...form.getValue(),
    }

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarLayoutEmail(payload)

    this.loadingSalvar = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao salvar o layout de e-mail.', 'error'))
      return
    }

    if (response.message) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'warning'))
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Layout de e-mail salvo com sucesso!', 'success'))
    }

    this.showModalEditar = false
    await this.carregarResumo()
  }

  abrirExclusao(item: ResumoTipoNotificacao) {
    this.itemEmExclusao = item
    this.showModalExcluir = true
  }

  async excluir() {
    if (!this.itemEmExclusao) {
      return
    }

    this.loadingExcluir = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.excluirLayoutEmail(this.selectedHospitalId, this.itemEmExclusao.tipo.key)

    this.loadingExcluir = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao excluir o layout de e-mail.', 'error'))
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage('Layout de e-mail excluído com sucesso!', 'success'))
    this.showModalExcluir = false
    await this.carregarResumo()
  }

  async carregarHospitais() {
    this.loadingHospitais = true

    const grupoResponse = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoHospital()

    if (!grupoResponse.success || !grupoResponse.data || !grupoResponse.data.id) {
      this.loadingHospitais = false
      return
    }

    const hospitaisResponse = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisPorGrupo(grupoResponse.data.id)

    if (hospitaisResponse.success) {
      this.fontePagadoraList = (hospitaisResponse.data || []).map((hospital: any) => ({
        ...hospital,
        disabled: !hospital.podeConfigurar,
      }))

      const primeiroConfiguravel = this.fontePagadoraList.find(hospital => hospital.podeConfigurar)

      if (primeiroConfiguravel) {
        this.selectedHospitalId = primeiroConfiguravel.id
      }
    }

    this.loadingHospitais = false
  }

  async mounted() {
    await this.carregarHospitais()
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }
}
